import { LinkButton, useDeviceType } from '@cian/ui-kit';
import * as styles from './styles.css';

import { NBSP } from 'shared/constants/symbols';
import { clsx } from 'clsx';
import { TG_CHANNEL_LINK } from 'shared/constants/links';

export const TelegramBanner: React.FC = () => {
  const device = useDeviceType();

  return (
    <div className={clsx(styles['container'], styles[device])}>
      <div className={styles['wrapper']}>
        <div className={styles['textblock']}>
          <div className={styles['title']}>
            Циан продолжает менять рынок недвижимости и задавать стандарты цифровизации. Но это только начало. {NBSP}
          </div>
          <div className={styles['description']}>
            Хотите знать, что будет дальше? Следите за{NBSP}обновлениями{NBSP}в нашем Telegram-канале для{NBSP}
            инвесторов Cian x IR!
          </div>
          <div className={styles['btn-container']}>
            <LinkButton fullWidth href={TG_CHANNEL_LINK} target="_blank" size={device === 'phone' ? 'M' : 'L'}>
              Присоединиться
            </LinkButton>
          </div>
        </div>
        <div className={styles['image']} />
      </div>
    </div>
  );
};
